<template>
  <div class="mobile-nav-drawer">
    <v-list class="pa-0 flex-grow-1" bg-color="transparent" density="comfortable" nav>
      <section v-for="item in navItemsToDisplay" :key="item.link">
        <v-list-item
          class="nav-item"
          link
          :target="getLinkAttrs(item).target"
          :to="getLinkAttrs(item).to"
          :href="getLinkAttrs(item).href"
          :disabled="isItemDisabled(item)"
          @click="handleListItemButtonClick(item)">
          <template #prepend>
            <v-icon class="mr-3" color="white" size="22">{{ item.icon }}</v-icon>
          </template>
          <v-list-item-title class="nav-item__title">{{ item.title }}</v-list-item-title>
        </v-list-item>
      </section>

      <v-list-item class="nav-item" @click="logout">
        <template #prepend>
          <v-icon class="mr-3" color="white" size="22">mdi-logout</v-icon>
        </template>
        <v-list-item-title class="nav-item__title">
          {{ $t('navigation.accountDropdown.logOut') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>

    <div class="mobile-nav-footer flex-shrink-0 px-4 pt-3 pb-6 text-center">
      <secondary-button
        block
        class="mb-3 non-uppercase"
        small
        @click="setRenderMode(renderModeEnum.DESKTOP)">
        <v-icon class="mr-2" size="small">mdi-laptop</v-icon>
        {{ $t('navigation.buttons.viewDesktopVersion') }}
      </secondary-button>
      <div class="d-flex align-center justify-center">
        <connection-status-indicator />
        <span class="version-number ml-2 is-uppercase text-grey-lighten-1">
          Nova v{{ $neutronVersion.major }}.{{ $neutronVersion.minor }}.{{
            $neutronVersion.patch
          }}
          – {{ $neutronVersion.commit }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { UserRole } from '@nova/core';
import NavigationDrawerBase from '@/components/elements/NavigationDrawerBase.vue';

export default {
  name: 'NavigationDrawerMobile',
  extends: NavigationDrawerBase,
  computed: {
    navItems() {
      return [
        {
          title: this.$t('navigation.sidebarLinks.appointments', 2),
          link: 'appointments',
          maximumRole: UserRole.OWNER,
          minimumRole: UserRole.SPECTATOR,
          icon: 'mdi-calendar'
        },
        {
          title: this.$t('navigation.sidebarLinks.help'),
          link: 'https://community.loadsmart.com/hc/en-us/sections/24987137080851-New-Warehouse-Portal-Opendock-Nova',
          maximumRole: UserRole.GOD,
          minimumRole: UserRole.BASE,
          icon: 'mdi-help-box',
          external: true,
          onClick: 'trackViewHelpPageInMixPanel'
        }
      ];
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('Auth/logout');
      window.location.replace('/login');
    }
  }
};
</script>

<style lang="scss" scoped>
/*
 * Root class deliberately avoids "v-navigation-drawer" — Vuetify's global stylesheet
 * matches that class and forces background: rgb(var(--v-theme-surface)) (white), which
 * makes white text invisible. Using a custom class keeps our transparent dark background.
 */
.mobile-nav-drawer {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  background: transparent;
  overflow-y: auto;

  :deep(.v-list) {
    background: transparent !important;
  }
}

/* Nav item rows */
.nav-item {
  background: transparent !important;
  border-radius: 8px !important;
  margin-bottom: 2px;

  :deep(.v-list-item__overlay) {
    background-color: #ffffff;
  }
}

.nav-item__title {
  color: #ffffff !important;
  font-size: 1rem !important;
  font-weight: 500;
}
</style>
